import styled from 'styled-components';
export const Header = styled.div`
    margin: 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    .header__buttons{
        display: flex;
        justify-content: space-between;
    }
    @media screen and (max-width: 600px) {
            .header__buttons{
                width: 80% ;
                flex-direction: column ;
            }
        };
`